// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

/**
 * Research Workbench shell authority — frontend-local route / slash metadata.
 *
 * `research_workbench` is intentionally NOT a bounded DeepAgent page entry in
 * `deepAgentRegistry.ts`. It is a premium single-page frontend shell over the
 * existing bounded runtimes. The shell still needs one local authority for its
 * route/slash/identity literals so launcher, handoff-card routing, and local
 * command-surface fallback do not drift.
 *
 * These values are a frontend drift lock against the backend control-plane
 * `research_workbench` entry added in PRE-001.
 */

export const RESEARCH_WORKBENCH_SURFACE = {
  key: 'research_workbench',
  agentId: 'research_workbench_agent',
  runtimeUrl: '/api/v1/chat/deepagents/research-workbench',
  path: '/research-workbench',
  slash: '/research-workbench',
  label: 'Research Workbench',
  launcherLabel: '科研',
  description: '单页科研工作台：统一建模中心与写作中心。',
  aliases: ['/research-wb', '/research-workbench'],
} as const;

export interface ResearchWorkbenchSurfaceEntry {
  key: typeof RESEARCH_WORKBENCH_SURFACE.key;
  agentId: typeof RESEARCH_WORKBENCH_SURFACE.agentId;
  runtimeUrl: typeof RESEARCH_WORKBENCH_SURFACE.runtimeUrl;
  path: typeof RESEARCH_WORKBENCH_SURFACE.path;
  slash: typeof RESEARCH_WORKBENCH_SURFACE.slash;
  label: typeof RESEARCH_WORKBENCH_SURFACE.label;
  description: typeof RESEARCH_WORKBENCH_SURFACE.description;
  aliases: readonly string[];
}

export function findResearchWorkbenchSurface(
  targetSurface: string,
): ResearchWorkbenchSurfaceEntry | undefined {
  if (targetSurface !== RESEARCH_WORKBENCH_SURFACE.key) {
    return undefined;
  }
  return RESEARCH_WORKBENCH_SURFACE;
}
